import { createContext, useContext } from 'react';

export const OverflowPortalContext = createContext<HTMLElement | null>(null);

export const useOverflowPortal = () => {
  return useContext(OverflowPortalContext);
};
